import { render, staticRenderFns } from "./iconGlobe.vue?vue&type=template&id=1f21cc94"
import script from "./iconGlobe.vue?vue&type=script&lang=js"
export * from "./iconGlobe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports